// Suppress ResizeObserver loop limit exceeded error
const suppressResizeObserverLoopError = () => {
  const resizeObserverError = "ResizeObserver loop completed with undelivered notifications.";
  
  window.addEventListener('error', (e) => {
    if (e.message === resizeObserverError) {
      e.stopImmediatePropagation();
    }
  });
};

export default suppressResizeObserverLoopError;
